import React, { useCallback } from 'react';
import { AppRemixIcon } from '@/layout/AppComponents';
import styled from 'styled-components';
import DebugMultiPressAlert from '../../../../../components/debug/DebugMultiPressAlert';

export default function ObligationCard({
  obligation,
  selectedObligationIDs,
  setFieldValue,
}) {
  const handleCheck = useCallback(() => {
    setFieldValue(
      'selectedObligationIDs',
      selectedObligationIDs.includes(obligation.id)
        ? selectedObligationIDs.filter((id) => id !== obligation.id)
        : [...selectedObligationIDs, obligation.id]
    );
  }, [obligation, selectedObligationIDs]);

  return (
    <>
      <Card className="list-group-item p-0" title={obligation?.id}>
        <div className="rs-check" onClick={handleCheck}>
          <DebugMultiPressAlert info={`ObligationID: ${obligation.id}`}>
            <AppRemixIcon
              icon={
                selectedObligationIDs?.includes(obligation.id)
                  ? 'checkbox'
                  : 'checkbox-blank'
              }
              size={20}
            />
          </DebugMultiPressAlert>
        </div>
        <div
          className="rs-obligationText"
          dangerouslySetInnerHTML={{
            __html: obligation?.obligation,
          }}
        />
      </Card>
    </>
  );
}

const Card = styled.div`
  display: grid;
  grid-template-columns: 60px 1fr;
  gap: 10px;
  height: 60px;
  .rs-check {
    display: flex;
    max-height: 60px;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border-right: 1px solid #ccc;
  }
  .rs-obligationText {
    overflow-y: auto;
  }
`;
